module.exports = require("acorn-import-meta");